import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d088e3fa&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d088e3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d088e3fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d088e3fa')) {
      api.createRecord('d088e3fa', component.options)
    } else {
      api.reload('d088e3fa', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d088e3fa&scoped=true&", function () {
      api.rerender('d088e3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C5LnIT3WcwM9/JS/comp/DocBox.vue"
export default component.exports